import React from 'react'
import { STEP_TYPE_ENUM, TASK_TYPE_ENUM } from 'services/api/constants'
import { Section, Title } from '../../../Shared'
import { BaseEditorContainer, EditorContentCardContainer } from '../../styles'
import Field from 'components/Shared/Fields'
import BaseDivider from '../../BaseDivider'
import { UploadType } from 'services/api/uploads'
import ExtraTextEditor from '../../ExtraTextEditor'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'
import { useNewTranslation } from 'hooks'
import { fieldIdentifiers } from 'components/Shared/Comment'
import { FormikTextListGroup } from 'particles/TextInputs/TextList/Group'
import Header from '../../Header'
interface PurchaseProductProps {
    taskType: TASK_TYPE_ENUM
    stepType: STEP_TYPE_ENUM
    stepNumber: number
    requiredFieldNames: string[]
    uuid?: string
}

const EXAMPLE_PHOTOS_LIMIT = 10

const PurchaseProduct: React.FC<PurchaseProductProps> = ({
    taskType,
    stepType,
    stepNumber,
    requiredFieldNames,
    uuid,
}) => {
    const [t] = useNewTranslation()

    return (
        <BaseEditorContainer id={uuid && uuid}>
            <EditorContentCardContainer>
                <Header taskType={taskType} />
                <Title taskType={taskType} stepType={stepType} stepNumber={stepNumber} />
                <CampaignEditorInputFieldContainer>
                    <Field.TextInputField
                        className={'input-area'}
                        label={t('campaignEditor.createTask.enterStepTitleHeader')}
                        placeholder={t('placeholderText.enterStepTitlePurchaseProduct')}
                        name={`stepData.${stepType}.data.title`}
                        isRequired={requiredFieldNames.includes('title')}
                        width={'100%'}
                        identifier={`${uuid}_${fieldIdentifiers.stepTitle}`}
                    />
                </CampaignEditorInputFieldContainer>
                <BaseDivider />
                <Section
                    title={t('campaignEditor.createTask.describeProductHeader')}
                    subtitle={t('campaignEditor.createTask.describeProductSubtext')}
                >
                    <CampaignEditorInputFieldContainer>
                        <Field.TextInputField
                            className={'input-area'}
                            label={t('campaignEditor.createTask.productNameHeader')}
                            name={`stepData.${stepType}.data.product_name`}
                            isRequired={requiredFieldNames.includes('product_name')}
                            width={'100%'}
                            identifier={`${uuid}_${fieldIdentifiers.productName}`}
                        />
                        <Field.TextAreaField
                            label={t('campaignEditor.createTask.productDescriptionHeader')}
                            name={`stepData.${stepType}.data.description`}
                            isRequired={requiredFieldNames.includes('description')}
                            width={'100%'}
                            minTextAreaHeight={76}
                            showInputLength
                            maxInputLength={200}
                            identifier={`${uuid}_${fieldIdentifiers.productDescription}`}
                        />
                        <FormikTextListGroup
                            title={t('campaignEditor.createTask.enterInstructionsHeader')}
                            subtitle={t('campaignEditor.createTask.enterProductPurchaseInstructionsSubtext')}
                            placeholder={t('placeholderText.enterInstructionBulletPoint')}
                            isRequired={requiredFieldNames.includes('how_to_buy')}
                            buttonText={t('button.addBulletPoint')}
                            name={`stepData.${stepType}.data.how_to_buy`}
                            width={'100%'}
                            identifier={`${uuid}_${fieldIdentifiers.howToBuyTitle}`}
                        />
                        <Field.ImageUploadField
                            title={t('campaignEditor.createTask.productPhotosHeader')}
                            subtitle={t('campaignEditor.createTask.productPhotosSubtext')}
                            presetType={UploadType.CAMPAIGN}
                            maxFiles={EXAMPLE_PHOTOS_LIMIT}
                            name={`stepData.${stepType}.data.example_photos`}
                            isRequired={requiredFieldNames.includes('example_photos')}
                            uploadContainerWidth="594px"
                            identifier={`${uuid}_${fieldIdentifiers.productPhotos}`}
                        />
                        <Field.TextAreaField
                            label={t('campaignEditor.createTask.productDescriptionHeader')}
                            name={`stepData.${stepType}.data.example_photos_description`}
                            isRequired={requiredFieldNames.includes('example_photos_description')}
                            width={'100%'}
                            minTextAreaHeight={76}
                            identifier={`${uuid}_${fieldIdentifiers.photosDescription}`}
                        />
                    </CampaignEditorInputFieldContainer>
                </Section>
                <CampaignEditorInputFieldContainer>
                    <ExtraTextEditor name={`stepData.${stepType}.data.extra_data`} isRequired />
                </CampaignEditorInputFieldContainer>
            </EditorContentCardContainer>
        </BaseEditorContainer>
    )
}

export default PurchaseProduct
